import { ReactComponent } from "./ic_alert_nostart.svg";

interface Props {
  fill?: string;
  className?: string;
  width?: string;
  height?: string;
}

const NoStartIcon: React.FC<Props> = (Props) => <ReactComponent {...Props} />;

export default NoStartIcon;
